// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__n53BT","header":"MergedInvoice_header__1Yn-t"};